export function normalizeTaskTitle(value) {
  return String(value ?? '')
    .trim()
    .replace(/\s+/g, ' ');
}

export function readTaskTitleFromForm(form, fallbackValue = '') {
  const titleField = form?.elements?.namedItem?.('title');
  return normalizeTaskTitle(titleField?.value ?? fallbackValue);
}

export function readTaskDescriptionFromForm(form, fallbackValue = '') {
  const descriptionField = form?.elements?.namedItem?.('description');
  return String(descriptionField?.value ?? fallbackValue ?? '');
}
